/* Class Mate etkileşimleri: sepete ekle (Horizon sepet çekmecesiyle), damla testi kaydırıcı,
   "ne zaman hangisi" sekmeleri, mobil satın alma çubuğu. */
import { CartLinesUpdateEvent } from '@shopify/events';

// Server-rendered native Shopify locale strings. No client-side translation service.
const cmLocale = document.documentElement.lang || 'tr';
const cmText = (key, values = {}) => {
  let result = (window.cmI18n || {})[key] || '';
  Object.entries(values).forEach(([name, value]) => { result = result.replaceAll('__' + name.toUpperCase() + '__', String(value)); });
  return result;
};
const cmEscape = (value) => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const cmNumber = (value) => Number(value).toLocaleString(cmLocale === 'ar' ? 'ar-TR' : cmLocale);


if (!window.__cmInit) {
  window.__cmInit = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Bildirim ---------- */
  let toastTimer;
  function toast(html) {
    let el = document.querySelector('.cm-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cm cm-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    requestAnimationFrame(() => el.classList.add('is-on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 4500);
  }

  /* ---------- Sepete ekle ---------- */
  async function addToCart(btn) {
    const ids = btn.dataset.cmAdd.split(',').filter(Boolean);
    const qty = Math.max(1, parseInt(btn.dataset.cmQty || '1', 10) || 1);
    const lines = ids.map((id) => ({ id: Number(id), quantity: qty }));
    const label = btn.innerHTML;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);

    let deferred = null;
    try {
      deferred = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
          promise: deferred.promise,
        })
      );
    } catch (e) {
      deferred = null;
    }

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines, sections: sectionIds.join(',') }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || cmText('error'));

      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      if (deferred) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'cm-add', sourceId: 'cm', itemCount: lines.reduce((n, l) => n + l.quantity, 0), sections: data.sections, didError: false },
        });
      }

      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      btn.textContent = cmText('added');
      setTimeout(() => {
        btn.classList.remove('is-done');
        btn.innerHTML = label;
        btn.removeAttribute('aria-busy');
      }, 2200);

      // Sepet çekmecesini aç; çekmece yoksa kısa bildirim göster
      const drawer = document.querySelector('cart-drawer-component');
      const themeDrawer = drawer && drawer.closest('theme-drawer');
      if (themeDrawer && typeof themeDrawer.open === 'function') {
        setTimeout(() => { if (!themeDrawer.isOpen) themeDrawer.open(); }, 150);
      } else {
        toast(`${cmEscape(cmText('added_count', {count: ids.length}))} <a href="${root}cart">${cmEscape(cmText('view_cart'))}</a>`);
      }
    } catch (err) {
      if (deferred) deferred.reject(err);
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      btn.innerHTML = label;
      toast(cmEscape(err.message || cmText('error')));
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cm-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---------- Kaydırıcılar ---------- */
  document.addEventListener('input', (e) => {
    const input = e.target.closest('.cm-ba input');
    if (input) input.closest('.cm-ba').style.setProperty('--pos', input.value + '%');
  });


  /* ---------- Kargo hesaplayıcı ---------- */
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-cm-calc] input');
    if (!input) return;
    const out = input.closest('[data-cm-calc]').querySelector('.cm-calc-out');
    const v = parseFloat(String(input.value).replace(',', '.'));
    if (!isFinite(v) || v <= 0) { out.textContent = cmText('calc_prompt'); return; }
    if (v >= 500) out.textContent = cmText('calc_free', {total: cmNumber(v)});
    else out.textContent = cmText('calc_paid', {total: cmNumber(v + 75), remaining: cmNumber(500 - v)});
  });

  /* ---------- Sekmeler ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-cm-tab]');
    if (!tab) return;
    const wrap = tab.closest('[data-cm-tabs]');
    wrap.querySelectorAll('[data-cm-tab]').forEach((b) => {
      const on = b === tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    wrap.querySelectorAll('[data-cm-panel]').forEach((p) => {
      p.hidden = p.dataset.cmPanel !== tab.dataset.cmTab;
    });
  });
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest('[data-cm-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    const tabs = [...tab.parentElement.querySelectorAll('[data-cm-tab]')];
    const rtl = getComputedStyle(tab.parentElement).direction === 'rtl';
    const delta = (e.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
    const next = tabs[(tabs.indexOf(tab) + delta + tabs.length) % tabs.length];
    next.focus();
    next.click();
  });

  /* ---------- Mobil satın alma çubuğu ---------- */
  const initSticky = () => {
    const bar = document.querySelector('[data-cm-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    const watch = [...document.querySelectorAll('[data-cm-hide-sticky]')];
    const visible = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => (en.isIntersecting ? visible.add(en.target) : visible.delete(en.target)));
      bar.classList.toggle('is-on', visible.size === 0);
    });
    watch.forEach((w) => io.observe(w));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
}

/* ---------- Ana sayfa banner kaydırıcı ---------- */
const initBanners = () => {
  document.querySelectorAll('[data-cm-slider]').forEach((slider) => {
    if (slider.__cm) return;
    slider.__cm = true;
    const track = slider.querySelector('[data-cm-track]');
    const slides = [...track.children];
    const dotsWrap = slider.querySelector('[data-cm-dots]');
    const ui = slider.querySelector('.cm-banners-ui');
    if (slides.length < 2) { if (ui) ui.hidden = true; return; }

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cm-banners-dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', cmText('banner', {count: i + 1}));
      b.addEventListener('click', () => { stop(); go(i); });
      dotsWrap.appendChild(b);
      return b;
    });

    let index = 0;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    const mark = () => {
      dots.forEach((d, i) => d.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      slides.forEach((s, i) => {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        s.tabIndex = i === index ? 0 : -1;
      });
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) { index = i; }
        mark();
      });
    }, { passive: true });

    slider.querySelector('[data-cm-prev]').addEventListener('click', () => { stop(); go(index - 1); });
    slider.querySelector('[data-cm-next]').addEventListener('click', () => { stop(); go(index + 1); });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(index - 1); }
    });

    // Yavaş otomatik geçiş: etkileşimde durur, hareket azaltma tercihine uyar
    const secs = Number(slider.dataset.autoplay || 0);
    let timer = null;
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      if (!secs || !smooth || timer) return;
      timer = setInterval(() => { if (!document.hidden) go(index + 1); }, secs * 1000);
    };
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => track.addEventListener(ev, stop, { passive: true }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('focusin', stop);
    mark();
    start();
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBanners);
else initBanners();

/* ---------- Sepet: sözleşme onayı olmadan ödemeye geçilmez ---------- */
{
  let consented = true;
  try { consented = sessionStorage.getItem('cm-consent') !== '0'; } catch (e) {}
  const sync = () => {
    document.querySelectorAll('[data-cm-consent] input').forEach((i) => { i.checked = consented; });
    document.querySelectorAll('.cart__ctas').forEach((c) => c.classList.toggle('is-consented', consented));
  };
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cm-consent] input');
    if (!input) return;
    consented = input.checked;
    try { sessionStorage.setItem('cm-consent', consented ? '1' : '0'); } catch (err) {}
    const box = input.closest('[data-cm-consent]');
    box.classList.remove('is-error');
    box.querySelector('.cm-consent-err').hidden = true;
    sync();
  });
  // Ödeme butonu: onay yoksa durdur ve kutuyu göster
  window.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button[name="checkout"], a[href$="/checkout"]');
    if (!btn || consented) return;
    const scope = btn.closest('.cart__ctas') || document;
    const box = scope.querySelector('[data-cm-consent]');
    if (!box) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    box.classList.add('is-error');
    box.querySelector('.cm-consent-err').hidden = false;
    box.querySelector('input').focus();
  }, true);
  window.addEventListener('submit', (e) => {
    if (consented) return;
    const sub = e.submitter;
    if (sub && sub.name === 'checkout' && document.querySelector('[data-cm-consent]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  // Horizon sepeti yeniden çizdiğinde onay durumunu koru
  new MutationObserver(() => {
    const unsynced = [...document.querySelectorAll('[data-cm-consent] input')].some((i) => i.checked !== consented)
      || [...document.querySelectorAll('.cart__ctas')].some((c) => c.classList.contains('is-consented') !== consented);
    if (unsynced) sync();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
}

/* ---------- Mobil menü: link tıklanınca, geri gelince ve sepet açılınca kapanır ---------- */
{
  const closeMenus = () => {
    document.querySelectorAll('header-drawer').forEach((d) => {
      try { if (d.isOpen) d.close(); } catch (e) {}
    });
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('header-drawer a[href]');
    if (!a) return;
    const url = new URL(a.href, location.href);
    const samePage = url.pathname === location.pathname && url.hash;
    const target = samePage && document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (target) {
      // Aynı sayfadaki bölüme: önce menüyü kapat, sonra bölüme kaydır
      e.preventDefault();
      closeMenus();
      history.replaceState(null, '', url.hash);
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 380);
    } else {
      setTimeout(closeMenus, 0);
    }
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) closeMenus(); });
  window.addEventListener('hashchange', closeMenus);
  document.addEventListener('theme-drawer:open', closeMenus);
}

/* ---------- Rehber yazısı: içindekiler ---------- */
{
  const initToc = () => {
    const body = document.querySelector('[data-cm-article]');
    const toc = document.querySelector('[data-cm-toc]');
    if (!body || !toc) return;
    const hs = [...body.querySelectorAll('h2')];
    if (hs.length < 2) return;
    const list = toc.querySelector('ol');
    const slug = (t) => t.toLocaleLowerCase('tr').replace(/ı/g, 'i').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    hs.forEach((h, i) => {
      if (!h.id) h.id = 'b-' + (slug(h.textContent) || i);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      const links = [...list.querySelectorAll('a')];
      const io = new IntersectionObserver((ents) => {
        ents.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((l) => l.classList.toggle('is-on', l.getAttribute('href') === '#' + en.target.id));
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      hs.forEach((h) => io.observe(h));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initToc); else initToc();
}

/* ---------- Yorum kartları: uzun metinlerde "Devamını oku" ---------- */
{
  const initMore = () => {
    document.querySelectorAll('.cm-rv-card blockquote').forEach((q) => {
      const card = q.closest('.cm-rv-card');
      if (card.querySelector('.cm-rv-more') || card.classList.contains('is-open')) return;
      if (q.scrollHeight <= q.clientHeight + 2) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cm-rv-more';
      b.textContent = cmText('read_more');
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', () => {
        const open = card.classList.toggle('is-open');
        b.textContent = open ? cmText('read_less') : cmText('read_more');
        b.setAttribute('aria-expanded', String(open));
      });
      q.after(b);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMore);
  else initMore();
  window.addEventListener('load', initMore);
}

// Localize only internal content links; never payment, account, external or asset URLs.
const cmLocalizeContentLinks = () => {
  const root = window.Shopify?.routes?.root || '/';
  if (root === '/') return;
  document.querySelectorAll('.cm-prose a[href], .shopify-policy__body a[href]').forEach((a) => {
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    let url; try { url = new URL(href, location.origin); } catch { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === '/' && url.hash) {
      a.href = root + url.search + url.hash;
      return;
    }
    if (!/^\/(pages|products|collections|blogs)(\/|$)/.test(url.pathname)) return;
    a.href = root.replace(/\/$/, '') + url.pathname + url.search + url.hash;
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cmLocalizeContentLinks); else cmLocalizeContentLinks();


/* ---------- Toptan koli adedi ve kademe fiyatı ---------- */
(() => {
  const fmt = (n) => new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 }).format(n) + '\u00a0TL';
  const update = (card) => {
    const input = card.querySelector('.cm-qty input');
    let q = parseInt(input.value, 10);
    if (!isFinite(q) || q < 1) q = 1;
    if (q > 24) q = 24;
    if (String(q) !== input.value && document.activeElement !== input) input.value = q;
    const tiers = card.dataset.tiers.split(',').map(Number);
    const t = q >= 10 ? 2 : q >= 5 ? 1 : 0;
    card.querySelectorAll('tr[data-tier]').forEach((r) => r.classList.toggle('is-on', Number(r.dataset.tier) === t));
    const total = tiers[t] * 24 * q * 1.2;
    card.querySelector('[data-cm-koli-total]').textContent = fmt(total);
    card.querySelector('[data-cm-koli-meta]').textContent = `${q * 24} adet · KDV dahil`;
    card.querySelector('[data-cm-qty]').dataset.cmQty = q;
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cm-koli] [data-cm-step]');
    if (!b) return;
    const card = b.closest('[data-cm-koli]');
    const input = card.querySelector('.cm-qty input');
    input.value = Math.min(24, Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.cmStep)));
    update(card);
  });
  document.addEventListener('input', (e) => {
    const card = e.target.closest('[data-cm-koli]');
    if (card && e.target.matches('.cm-qty input')) update(card);
  });
  document.addEventListener('change', (e) => {
    const card = e.target.closest('[data-cm-koli]');
    if (card && e.target.matches('.cm-qty input')) { e.target.blur(); update(card); }
  });
})();
/* UGC videoları: görünürken oynat */
(function(){var vs=document.querySelectorAll('[data-cm-ugc] video');if(!vs.length)return;
if(!('IntersectionObserver' in window)){vs.forEach(function(v){v.preload='metadata';});return;}
var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{threshold:.5});
vs.forEach(function(v){io.observe(v);});})();
(function(){document.querySelectorAll('[data-cm-ugc]').forEach(function(w){var t=w.querySelector('[data-cm-ugc-track]');if(!t)return;w.querySelectorAll('[data-cm-ugc-dir]').forEach(function(b){b.addEventListener('click',function(){t.scrollBy({left:(+b.dataset.cmUgcDir)*t.clientWidth*0.9,behavior:'smooth'});});});});})();
(function(){var bs=document.querySelectorAll('[data-cm-ugc-snd]');function set(b,on){var v=b.parentNode.querySelector('video');v.muted=!on;b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?b.dataset.on:b.dataset.off);}
bs.forEach(function(b){b.addEventListener('click',function(){var on=b.getAttribute('aria-pressed')!=='true';bs.forEach(function(o){if(o!==b)set(o,false);});set(b,on);var v=b.parentNode.querySelector('video');if(on){v.currentTime=0;var p=v.play();if(p&&p.catch)p.catch(function(){});}});});})();
(function(){var items=[].slice.call(document.querySelectorAll('[data-cm-ugc] .cm-ugc-item'));if(!items.length)return;
var lb,lv,cur=0,last;
function muteAll(){items.forEach(function(it){var b=it.querySelector('[data-cm-ugc-snd]');it.querySelector('video').muted=true;if(b){b.setAttribute('aria-pressed','false');b.setAttribute('aria-label',b.dataset.off);}});}
function build(){lb=document.createElement('div');lb.className='cm-ugc-lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
 lb.innerHTML='<button type="button" class="cm-ugc-lb-x" aria-label="Kapat">&times;</button><button type="button" class="cm-ugc-lb-nav cm-ugc-lb-prev" aria-label="Önceki">&#8249;</button><div class="cm-ugc-lb-stage"><video playsinline controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" disablepictureinpicture disableremoteplayback oncontextmenu="return false"></video><div class="cm-ugc-lb-bar"><button type="button" class="cm-ugc-lb-pp" aria-label="Oynat/Durdur"></button><div class="cm-ugc-lb-prog"><span></span></div><button type="button" class="cm-ugc-lb-snd" aria-label="Ses"></button></div></div><button type="button" class="cm-ugc-lb-nav cm-ugc-lb-next" aria-label="Sonraki">&#8250;</button><p class="cm-ugc-lb-cap"></p>';
 document.body.appendChild(lb);lv=lb.querySelector('video');
 lb.querySelector('.cm-ugc-lb-x').addEventListener('click',close);
 lb.querySelector('.cm-ugc-lb-prev').addEventListener('click',function(){show(cur-1);});
 lb.querySelector('.cm-ugc-lb-next').addEventListener('click',function(){show(cur+1);});
 lb.addEventListener('click',function(e){if(e.target===lb)close();});
 lv.addEventListener('ended',function(){show(cur+1);});
 var pp=lb.querySelector('.cm-ugc-lb-pp'),sb=lb.querySelector('.cm-ugc-lb-snd'),pr=lb.querySelector('.cm-ugc-lb-prog'),pf=pr.querySelector('span');
 function ui(){pp.classList.toggle('is-paused',lv.paused);sb.classList.toggle('is-muted',lv.muted);}
 function tog(){if(lv.paused){var p=lv.play();if(p&&p.catch)p.catch(function(){});}else lv.pause();}
 lv.addEventListener('click',tog);pp.addEventListener('click',tog);
 sb.addEventListener('click',function(){lv.muted=!lv.muted;ui();});
 ['play','pause','volumechange'].forEach(function(ev){lv.addEventListener(ev,ui);});
 lv.addEventListener('timeupdate',function(){pf.style.width=(lv.duration?lv.currentTime/lv.duration*100:0)+'%';});
 pr.addEventListener('click',function(e){var r=pr.getBoundingClientRect();if(lv.duration)lv.currentTime=(e.clientX-r.left)/r.width*lv.duration;});
 lv.addEventListener('dblclick',function(e){e.preventDefault();});
 var sx=null;lb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
 lb.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>60)show(cur+(dx<0?1:-1));sx=null;});
 document.addEventListener('keydown',function(e){if(!lb.classList.contains('is-open'))return;if(e.key==='Escape')close();if(e.key==='ArrowRight')show(cur+1);if(e.key==='ArrowLeft')show(cur-1);});}
function show(i){cur=(i+items.length)%items.length;var it=items[cur],v=it.querySelector('video');
 lv.src=v.querySelector('source').src;lv.poster=v.poster;lv.muted=false;lv.loop=false;lb.querySelector('.cm-ugc-lb-cap').textContent=it.querySelector('figcaption').textContent;
 var p=lv.play();if(p&&p.catch)p.catch(function(){lv.muted=true;lv.play();});}
function open(i){if(!lb)build();muteAll();last=document.activeElement;lb.classList.add('is-open');document.documentElement.classList.add('cm-noscroll');show(i);lb.querySelector('.cm-ugc-lb-x').focus();}
function close(){lv.pause();lv.removeAttribute('src');lv.load();lb.classList.remove('is-open');document.documentElement.classList.remove('cm-noscroll');if(last&&last.focus)last.focus();}
items.forEach(function(it,i){it.querySelector('video').addEventListener('click',function(){open(i);});var f=it.querySelector('[data-cm-ugc-full]');if(f)f.addEventListener('click',function(){open(i);});});})();
(function(){document.addEventListener('contextmenu',function(e){if(e.target.closest&&e.target.closest('[data-cm-ugc],.cm-ugc-lb'))e.preventDefault();});})();
